import { Application } from "@hotwired/stimulus";
import { StreamActions } from "@hotwired/turbo";

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

export { application };

// Nodig voor scroll_to_top
// op formulieren die niet naar een 'view' redirecten
//  turbo_stream.action(:scroll_to_top, '')
StreamActions.scroll_to_top = function () {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
